import styled, { keyframes } from 'styled-components';
import GDBREAKPOINTS from '@gameday/components/themes/breakpoints';

const { SM_MIN } = GDBREAKPOINTS;
const MatchupAnimation = keyframes`
  from {
    opacity: 0;
  }
  to  {
    opacity: 1;
  }
`;
export const MatchupDetailsContainer = styled.div`
    font-family: var(--gameday-primary-font);
    display: flex;
    justify-content: center;
    font-size: 12px;
    line-height: 12px;
    font-weight: 700;
    padding: 8px 0;
    margin-bottom: 0;
    min-height: 20px;
    @media (min-width: ${SM_MIN}) {
      padding: 8px 0 0 0;
      margin-bottom: -8px;
    }
`;

export const MatchupDetailsWrapper = styled.div`
    display:block;
`;

export const MatchupDetailsLabel = styled.div`
    color: var(--gameday-secondary-font-color);
    animation: 1s ${MatchupAnimation} ease-in-out;
`;

export const MainWrapper = styled.div`
    margin-top: 16px;
`;
